import { render, staticRenderFns } from "./AllergyHistory.vue?vue&type=template&id=452c35da&scoped=true"
import script from "./AllergyHistory.vue?vue&type=script&lang=js"
export * from "./AllergyHistory.vue?vue&type=script&lang=js"
import style0 from "./AllergyHistory.vue?vue&type=style&index=0&id=452c35da&prod&lang=less"
import style1 from "./AllergyHistory.vue?vue&type=style&index=1&id=452c35da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c35da",
  null
  
)

export default component.exports